import React from "react"
import {
  Container,
  Heading,
  Box,
  Grid,
  Text,
  Image,
  Flex,
} from "@theme-ui/components"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { InboundLink } from "./link"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import { getPagePath, getProductPath } from "../utils/path"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"

import "swiper/css/navigation"
import "swiper/css/pagination"
import { Navigation, Pagination } from "swiper/modules"
import ButtonArrowDefault from "../images/button-arrow-default.svg"

const ProjectCollection = ({ block }) => {
  const locale = React.useContext(LanguageSwitcherContext).activeLocale

  return (
    <Container variant="fw" sx={{ mt: 5 }}>
      <Grid columns={[1, 1, "1fr 2fr"]} gap={[4, 4, 4, 9]}>
        <Flex
          sx={{
            flexDirection: "column",

            gap: [3, 3, 3, "30px"],
            a: {
              backgroundColor: "primary",
              borderRadius: "40px",

              color: "white",
              width: ["250px", "280px", "400px", "fit-content"],

              fontFamily: "mono",

              textTransform: "uppercase",
              fontSize: block.contact
                ? [1, 1, 1, "30px"]
                : ["12px", "12px", "12px!important", "14px!important"],
              p: 3,
              textDecoration: "none",
              px: 3,
              ":hover": {
                backgroundColor: "secondary",
              },
            },
          }}
        >
          <Text
            variant="kicker"
            sx={{ whiteSpace: "nowrap", my: 0, fontSize: [1, 1, 1] }}
          >
            {block.kicker}
          </Text>
          <Heading variant="h3" sx={{ color: "dark", fontSize: ["34px"] }}>
            {block.title}
          </Heading>

          <InboundLink to={getPagePath(block.link.link, locale)}>
            {block.link.anchor}
          </InboundLink>
        </Flex>
        <Box
          sx={{
            ".swiper": {
              width: "100%",
              height: "100%",
            },
            ".swiper-slide": {
              width: "25%",
              height: "90%",
            },
            ".swiper-horizontal > .swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal":
              {
                display: ["none", "none", "block"],
                bottom: "0",

                ".swiper-pagination-bullet": {
                  color: "dark",
                  opacity: 1,
                  backgroundColor: "dark",
                },
              },
            ".swiper-pagination": {
              span: { backgroundColor: "dark" },
            },
            ".swiper-pagination-bullet-active": {
              backgroundColor: "#9C73FF!important",
            },
            ".swiper-button-next, .swiper-button-prev ": {
              backgroundColor: "#9C73FF!important",
              width: "40px",
              height: "40px",

              borderRadius: "50%",
              color: "light",
              "&::after": {
                fontSize: [4],
              },
              ".swiper-pagination-bullets": {
                textAlign: ["end", "center"],
                position: "block",
                backgroundColor: "#9C73FF!important",
                bottom: "-50px",
              },
            },
            ".swiper-pagination": {
              bottom: "-50px",
            },
          }}
        >
          <Swiper
            spaceBetween={10}
            slidesPerView={2.5}
            pagination={{ clickable: true }}
            modules={[Navigation, Pagination]}
            breakpoints={{
              320: {
                slidesPerView: 1.2,
                spaceBetween: 20,
              },
              640: {
                slidesPerView: 2.5,
                spaceBetween: 20,
              },
              896: {
                slidesPerView: 2.5,
                spaceBetween: 20,
              },
            }}
          >
            {block.projects.map((project, index) => (
              <SwiperSlide key={index}>
                <InboundLink to={getProductPath(project, locale)}>
                  <Box
                    sx={{
                      position: "relative",
                      height: "100%",
                      width: "100%",
                      borderRadius: "80px",
                      "::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        borderRadius: "80px",
                        backgroundColor: "transparent",
                        transition: "background-color 0.3s",
                      },
                      ":hover::before": {
                        backgroundColor: "primary",
                      },
                      ":hover": {
                        ".project-title": {
                          opacity: 1,
                        },
                        ".arrow-icon": {
                          opacity: 1,
                          fill: "secodary",
                        },
                        ":hover .arrow-icon": {
                          fill: "secondary",
                        },
                      },
                    }}
                  >
                    <Image
                      src={project.imageThumb.url}
                      alt={project.title}
                      sx={{
                        height: "100%",
                        width: "100%",
                        borderRadius: "80px",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                    <Flex
                      sx={{
                        flexDirection: "column",
                        justifyContent: "center",
                        alignContent: "center",
                        alignItems: "center",
                        gap: 3,
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        textAlign: "center",
                        zIndex: 1,
                      }}
                    >
                      <Box
                        className="project-title"
                        sx={{
                          color: "dark",
                          fontSize: "15px",
                          fontFamily: "mono",
                          fontWeight: 500,
                          textTransform: "uppercase",
                          opacity: 0,
                        }}
                        dangerouslySetInnerHTML={{ __html: project.title }}
                      />
                      <Image
                        src={ButtonArrowDefault}
                        className="arrow-icon"
                        sx={{
                          width: "40px",
                          height: "40px",
                          opacity: 0,
                        }}
                      />
                    </Flex>
                  </Box>
                </InboundLink>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Grid>
    </Container>
  )
}

export default ProjectCollection
